import { CalendarOption, useLocale } from "@dgs/core";
import { eachMonthOfInterval, eachYearOfInterval, endOfYear, startOfYear } from "date-fns";
import { useMemo } from "react";

export const useCalendarNavigationOptions = (selectedDate: Date) => {
	const { language } = useLocale();

	const monthOptions = useMemo(
		(): CalendarOption[] =>
			eachMonthOfInterval({ start: startOfYear(selectedDate), end: endOfYear(selectedDate) }).map((date) => ({
				value: date.getMonth(),
				name: Intl.DateTimeFormat(language, { month: "short" }).format(date),
			})),
		[selectedDate, language],
	);

	const yearOptions = useMemo((): CalendarOption[] => {
		return eachYearOfInterval({
			start: new Date().setFullYear(new Date().getFullYear() - 10),
			end: new Date().setFullYear(new Date().getFullYear() + 10),
		}).map((date) => ({
			value: date.getFullYear(),
			name: Intl.DateTimeFormat(language, { year: "numeric" }).format(date),
		}));
	}, [language]);

	return { monthOptions, yearOptions };
};
